<script setup lang="ts">
const props = defineProps<{
  superAdministrationName: string;
}>();

const { t } = useI18n();

const superAdministrationNameComputed = computed(
  () => props.superAdministrationName,
);
</script>

<template>
  <h4 class="mb-6 text-gray-900">
    {{ t("administration.superAdministration.settings.information.subtitle") }}
  </h4>
  <lxc-form-item
    class="w-1/4"
    :label="
      t('administration.superAdministration.settings.information.nameLabel')
    "
    disabled
  >
    <lxc-input v-model="superAdministrationNameComputed" type="text" />
  </lxc-form-item>
</template>
